<template>
  <div>
    <span v-for="option in options" :key="option" class="option" :class="[{ active: theme === option }, `option--${option}`]" @click.stop.prevent="update(option)"></span>
  </div>
</template>

<script>
  export default {
    props: ['theme'],
    
    data() {
      return {
        options: ['default', 'light', 'dark', 'dark-inverted', 'blue', 'gold', 'chroma']
      }
    },

    methods: {
      update(option) {
        this.$emit('update:theme', option);
      }
    }
  }
</script>

<style scoped>
  .option.active:before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 1px solid #000;
  }

  .option {
    position: relative;
    display: inline-block;

    height: 1em;
    width: 1em;
    margin: 2px;
    border: 1px solid #fff;

    margin-right: 0.35em;
  }

  .option--default {
    background: #fff;
  }

  .option--default:after {
    content: '';
    position: absolute;

    border-top: 2px solid red;
    width: calc(100% + 6px);

    transform: rotate(45deg);
    transform-origin: 0% 0%;
  }

  .option--light {
    background: #ddd;
  }

  .option--dark {
    background: #111;
  }

  .option--dark-inverted {
    background: #222;
  }

  .option--dark-inverted:after {
    content: '';

    position: absolute;
    top: calc(65% - 1px);
    bottom: 1px;
    left: 1px;
    right: 1px;
    background: rgb(0, 255, 0);
  }

  .option--blue {
    background: rgb(67, 110, 175);
  }

  .option--gold {
    background: rgb(235, 204, 102);
  }

  .option--chroma {
    background: rgba(35, 98, 175, 0.5);
  }
</style>